<template>
  <div id = "stepper">
    <h1 class = "timeline-title"> Timeline EESTEC Olympics 9</h1>
    <v-stepper non-linear v-if="!isMobile">
      <!-- horizontal component -->
      <v-stepper-header>
        <div v-for = "(step, index) in timeline" :key="index">
          <v-stepper-step  :step="index + 1" editable>
            {{step.header}}
          </v-stepper-step>
          <v-divider v-if="index !== timeline.length - 1" />
        </div>
      </v-stepper-header>
      <v-stepper-items v-if="!isMobile">
        <v-stepper-content v-for = "(step, index) in timeline" :key="index" :step="index + 1">
          <v-card class = "stepper-card" color="white">
            <h1 class = "card-title"> {{ step.card.title }} </h1>
            <h2 class = "card-subtitle"> {{ step.card.program }} </h2>
            <h2 class = "card-subtitle"><a :href="step.card.link">{{$t(step.card.location)}}</a></h2>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>


    <!-- vertical component -->
    <v-stepper non-linear v-if="isMobile" vertical>
      <div v-for = "(step, index) in timeline" :key="index">
        <v-stepper-step :step="index + 1" editable>
          {{step.header}}
        </v-stepper-step>
        <v-stepper-content :step="index + 1">
          <v-card class = "stepper-card" color="white">
            <h1 class = "card-title"> {{ step.card.title }} </h1>
            <h2 class = "card-subtitle"> {{ step.card.program }} </h2>
            <h2 class = "card-subtitle"><a :href="step.card.link">{{$t(step.card.location)}}</a></h2>
          </v-card>
        </v-stepper-content>
      </div>
    </v-stepper>
  </div>
</template>

<script>
import timeline from '@/assets/resources/timeline.js'

export default {
  data() {
    return {
      isMobile: false,
      timeline
    }
  },
  created() {
    this.isMobile = window.innerWidth < 600 ? true : false; 
  }
}
</script>

<style lang="scss">
#stepper {
  @extend %eestec-page;
  padding-bottom: 30px;
}

.timeline-title {
  font-size: 32px;
  margin-top: 30px;
  margin-bottom: 30px;
}

.card-title {
  font-size: 32px;
  font-weight: bold;
}

.card-subtitle {
  font-size: 24px;
  font-weight: normal;
}

.v-sheet {
  box-shadow: unset;
}

.v-stepper__header > div {
  display: flex;
  align-items: center;
  flex-grow: 1;
}

.v-stepper__step__step {
  background-color: $primary-color !important;
}

.card-subtitle > a {
  text-align: center;
  color: $secondary-color;
}

.card-subtitle > a:hover {
  text-decoration: underline;
}

.v-stepper--vertical .v-stepper__content {
  margin-left: 0;
}
</style>
